import { useRef, useEffect } from 'react';

const DateRangeFilter = ({
  dateRange,
  setDateRange,
  showCustomDatePicker,
  setShowCustomDatePicker,
  customStartDate,
  setCustomStartDate,
  customEndDate,
  setCustomEndDate,
  isLoading,
  fetchSummaryData
}) => {
  const popupRef = useRef(null);

  useEffect(() => {
    if (!showCustomDatePicker) return;
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setShowCustomDatePicker(false);
        if (dateRange === 'custom') setDateRange('7d');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showCustomDatePicker, dateRange, setShowCustomDatePicker, setDateRange]);

  return (
    <div className="relative" ref={popupRef}>
      <select
        value={dateRange}
        disabled={isLoading}
        onChange={(e) => {
          const val = e.target.value;
          setDateRange(val);
          setShowCustomDatePicker(val === 'custom');
        }}
        className="h-[34px] border border-gray-200 rounded-lg bg-white px-3 py-1.5 text-[14px] font-medium text-gray-700 focus:outline-none focus:ring-1 focus:ring-primary"
      >
        <option value="24h">Last 24 hours</option>
        <option value="7d">Last 7 days</option>
        <option value="30d">Last 30 days</option>
        <option value="90d">Last 90 days</option>
        <option value="custom">Custom</option>
      </select>

      {showCustomDatePicker && (
        <div className="absolute right-0 top-full mt-1 z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-4 flex flex-col gap-3 min-w-max">
          <div className="flex items-center gap-2">
            <label htmlFor="start-date" className="text-sm text-gray-600 w-10">From:</label>
            <input
              id="start-date"
              type="date"
              className="border border-gray-200 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
              value={customStartDate}
              onChange={(e) => setCustomStartDate(e.target.value)}
              max={customEndDate}
            />
          </div>
          <div className="flex items-center gap-2">
            <label htmlFor="end-date" className="text-sm text-gray-600 w-10">To:</label>
            <input
              id="end-date"
              type="date"
              className="border border-gray-200 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-primary"
              value={customEndDate}
              onChange={(e) => setCustomEndDate(e.target.value)}
              min={customStartDate}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          <button
            className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-secondary text-white rounded-lg hover:bg-secondaryDark self-end"
            onClick={() => { fetchSummaryData(); setShowCustomDatePicker(false); }}
            disabled={isLoading}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
